import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ModalComponent} from '@core/modal.component';
import { StockItem } from '@entities/stock.entity';
import Swiper from 'swiper';
import {FormGroup} from '@angular/forms';
import {CatalogService} from '@models/catalog.service';
import {FeedbackModelService} from '@models/feedback.service';
import {InputState} from '@entities/enums';
import {AppService} from '@services/app.service';
import {CordovaService} from '@services/cordova.service';
import {IonContent} from '@ionic/angular';

@Component({
  selector: 'app-stock-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss']
})

export class StockModalComponent extends ModalComponent implements AfterViewInit {
  cdr = inject(ChangeDetectorRef);
  appService = inject(AppService);
  catalogService = inject(CatalogService);
  feedbackModelService = inject(FeedbackModelService);
  cordovaService = inject(CordovaService);
  stocks: StockItem[];
  stockId: number;
  isLoaded: boolean[] = [];
  formSendingId = null;
  formSendingLoader = false;
  news = false;
  resultMessage = '';
  swiper!: Swiper;

  // ViewChild для контейнера и слайдов
  @ViewChild('slider') slider: ElementRef;
  @ViewChild('modalHeight') modalHeight: IonContent;  // ion-content
  @ViewChild(IonContent) ionContent: IonContent;
  // Используем ViewChildren для доступа ко всем элементам слайдов
  @ViewChildren('item') items: QueryList<ElementRef>;

  getFormItemById(id: number): FormGroup {
    return this.catalogService.formItemsArray.controls.find(formGroup => formGroup.get('id').value === id) as FormGroup;
  }

  getFormControlState(controlName, id: number) {
    const formItem = this.getFormItemById(id);
    const control = formItem.get(controlName);
    return (control.invalid && !control.untouched ? 'error' : null) as InputState;
  }

  getFormControlError(controlName, id: number) {
    const formItem = this.getFormItemById(id);
    const control = formItem.get(controlName);
    return (control.invalid && !control.untouched ? 'error' : null) as InputState;
  }

  ngAfterViewInit() {
    const style = document.createElement('style');
    style.innerHTML = `
      .swiper-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .swiper-pagination-bullet {
        transition: width .3s;
        border: none;
        display: block;
      }
      .swiper-pagination-bullet-active {
        width: var(--pagination-bullet-width-active, 8px);
        border-radius: var(--pagination-bullet-radius-active, 50%);
      };
    `;
    this.slider.nativeElement.shadowRoot.appendChild(style);

    // Инициализация проверки высоты после инициализации swiper
    setTimeout(() => {
      this.checkContentHeight();
    }, 500);
  }

  ionViewWillEnter() {
    this.appService.bottomMainModal = false;
  }

  ionViewWillLeave() {
    if (this.appService.mainModalIsOpen) {
      this.appService.bottomMainModal = true;
    }
    this.clearAfterSendFormMessage();
  }

  async checkContentHeight() {
    // Используем метод getScrollElement() для доступа к DOM-элементу
    const scrollEl = await this.modalHeight.getScrollElement();
    const modalContentHeight = scrollEl.offsetHeight; // Получаем высоту контейнера

    // Индекс активного слайда
    const activeIndex = this.swiper?.activeIndex ?? 0;

    // Получаем активный элемент слайда
    const activeItem = this.items.toArray()[activeIndex]?.nativeElement;

    if (modalContentHeight && activeItem) {
      const itemHeight = activeItem.offsetHeight;

      const eightyPercentOfModal = modalContentHeight - 150;
      if (itemHeight < eightyPercentOfModal) {
        // Прокрутка вверх перед скрытием скролла
        await this.ionContent.scrollToTop(300); // 300ms - время анимации прокрутки

        // После завершения прокрутки скрываем скролл
        this.ionContent.getScrollElement().then((scrollEl) => {
          scrollEl.style.overflow = 'hidden';
        });
      } else {
        this.ionContent.getScrollElement().then((scrollEl) => {
          scrollEl.style.overflow = '';
        });
      }
    }
  }

  init(element: any) {
    this.swiper = element.detail[0];
    const currentId = this.stocks.findIndex(item => item.id === this.stockId);
    this.swiper.slideTo(currentId, 0);

    // Проверка высоты при смене слайда
    this.swiper.on('slideChange', () => {
      this.checkContentHeight();  // Проверяем высоту при смене слайда
      this.clearAfterSendFormMessage();
    });
  }

  onImagesLoad(index: number) {
    this.isLoaded[index] = true;
    // Перепроверяем высоту при загрузке изображения
    this.checkContentHeight();
  }

  async sendForm(id: number) {
    this.formSendingId = id;
    this.formSendingLoader = true;
    const res = await this.feedbackModelService.sendForm(this.getFormItemById(id).value);
    if (res) {
      this.resultMessage = res.message;
      this.formSendingLoader = false;
      if (res.status) {
        this.clearForm(id);
      }
    }
  }

  clearAfterSendFormMessage() {
    this.formSendingId = null;
    this.resultMessage = '';
  }

  clearForm(id: number) {
    const formItem = this.getFormItemById(id);

    if (formItem) {
      // Очищаем значение, кроме id и помечаем все контролы как untouched
      Object.keys(formItem.controls).forEach(controlName => {
        if (controlName !== 'id') {
          const control = formItem.get(controlName);
          control.setValue('');
          control.markAsUntouched();
        }
      });
    }
  }

  handleFocus(textarea = false) {
    this.appService.bottomPanelNeedHidden = true;
    if (textarea) {
      this.ionContent.scrollToBottom(0);
    }
  }

  blurFocus() {
    this.appService.bottomPanelNeedHidden = false;
  }
}
